import { Component, OnInit } from '@angular/core';
import { Sudoku } from './class/sudoku';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  sudoku: any;
  showHints: boolean = false;
  difficulties = [ 'easy', 'medium', 'hard', 'very Hard' ];
  
  difficulty: string = 'medium';

  constructor(){}

  ngOnInit(){
    this.renderAnimatingSudoku();
  }

  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  renderAnimatingSudoku(){

    const difficulties = { 'easy': 25, 'medium': 50, 'hard': 60, 'very Hard': 70 };

    this.sudoku = new Sudoku(difficulties[this.difficulty]);
    this.sudoku.giveAnimating();
    console.log(this.sudoku);
  }

  addValueToCell(cell: any, val: number){
    cell.isValid = this.sudoku.checkIfValid(cell, val);
    cell.val = val;
  }

}
